export default __webpack_public_path__ + "static/media/avatar.0ded4958.png";